import React from 'react';
import Paper from '@mui/material/Paper';
import Grid2 from "@mui/material/Grid2";
import Typography from '@mui/material/Typography';
import Link from "@mui/material/Link";
import {useSxStyles as sx} from "../styles/sxStyles";

const ContactUs = () => {

    return <>
        <Typography variant="h5" color='primary' style={{marginLeft: '4rem', marginTop: '1.5rem'}}>Contact Us</Typography>
        <Paper elevation={3} sx={{...sx.controlPanel, padding: "2rem",
                margin: "4rem 8rem",
                textAlign: "left",}}>
            <Grid2
                container
                spacing={3}
                justifyContent="center"
            >
                <Grid2 size={12}>
                    <Typography variant='h6'>
                        NEUMO payments can be contacted by calling Customer Service at (888) 407–0931
                        (Monday through Friday 8am – 5pm Mountain Time). You can also email our
                        Customer Service Department at any time at <Link
                        href="mailto:citepaysupport@avenuinsights.com">citepaysupport@avenuinsights.com</Link>.
                    </Typography>
                </Grid2>
            </Grid2>
        </Paper>
    </>;
}

export default ContactUs;
